export const isMarketOpenForBets = (status: string) => {
  return ["ACTIVE", "OPEN", "SUSPENDED"].includes(status);
};
